import React from 'react';
import clsx from 'clsx';
import ErrorMessage from './ErrorMessage';

const NotAuthorised = ({ className }) => (
  <ErrorMessage
    className={clsx('modal-message aridhia-not-authorised', className)}
    error={{
      title: 'unauthorised.header', message: 'unauthorised.message', translation: { on: true }, warning: true,
    }}
    icon="ban"
  />
);

export default NotAuthorised;
